import { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { PatternFormat } from 'react-number-format';

import TextFieldMui from '@mui/material/TextField';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import Stack from '@mui/material/Stack';
import FormControl from '@mui/material/FormControl';

const TextField = (props) => {
	const {
		label,
		helperText,
		format,
		mask = '_',
		allowEmptyFormatting,
		error,
		...other
	} = props;

	const [isPatternFocused, setPatternFocused] = useState(false);

	const handlePatternFocus = useCallback((e) => {
		setPatternFocused(true);
		e.target.addEventListener(
			'blur',
			() => {
				setPatternFocused(false);
			},
			{ once: true },
		);
	}, []);

	let inputNode = <TextFieldMui error={!!error} fullWidth {...other} />;

	if (format) {
		inputNode = (
			<PatternFormat
				allowEmptyFormatting={
					allowEmptyFormatting === undefined
						? isPatternFocused
						: allowEmptyFormatting
				}
				fullWidth
				format={format}
				mask={mask}
				error={!!error}
				customInput={TextFieldMui}
				onFocus={handlePatternFocus}
				{...other}
			/>
		);
	}

	return (
		<Stack spacing={1}>
			{label && <InputLabel>{label}</InputLabel>}
			<FormControl>
				{inputNode}
				{helperText && <FormHelperText>{helperText}</FormHelperText>}
				{error?.length && <FormHelperText error>{error}</FormHelperText>}
			</FormControl>
		</Stack>
	);
};

TextField.propTypes = {
	...TextFieldMui.propTypes,
	label: PropTypes.string,
	helperText: PropTypes.string,
	error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	allowEmptyFormatting: PropTypes.bool,
	format: PropTypes.string, // "+1 (###) ###-####"
	mask: PropTypes.string, // '_'
};

export default TextField;
